import React from "react";
import Chip from "@mui/material/Chip"; // Ensure you have Material-UI or adjust as necessary
import { TT } from "../../consts.js"; // Adjust path if needed

const TopTrackersCard = ({ data, colours }) => {
  return (
    <div style={colours.vboxSmall} className="vocalysd-card">
      <div className="vocalysd-heading">
        Top trackers
        <TT info={"Trackers that came up most frequently."} />
      </div>
      <div style={{ marginTop: 16 }}>
        {data.trackerhits ? (
          data.trackerhits.slice(0, 8).map((tracker, index) => (
            <Chip
              label={tracker.tracker}
              key={index}
              style={{ margin: 1, fontFamily: "Poppins" }}
            />
          ))
        ) : null}
      </div>
    </div>
  );
};

export default TopTrackersCard;